import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { charmGray, grayIconFill, header, titles } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	charCount: {
		color: header,
		display: 'flex',
		fontSize: 12,
		justifyContent: 'flex-end',
		marginRight: 10,
		...CssSelectors.allDescendants(
			{
				display: 'flex',
				paddingRight: 6,
			},
			'button'
		),
	},
	composerContainer: {
		marginTop: 10,
	},
	container: {
		color: grayIconFill,
		fontSize: 14,
		marginBottom: 72,
	},
	header: {
		color: titles,
		fontSize: 18,
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 20,
	},
	labelContainer: {
		alignItems: 'flex-end',
		color: charmGray,
		display: 'flex',
		fontSize: 14,
		justifyContent: 'space-between',
		paddingBottom: 10,
	},
	labelEmoji: {
		alignItems: 'center',
		display: 'flex',
	},
	mediaContainer: {
		color: charmGray,
		fontSize: 14,
		marginTop: 48,
	},
	mentionAnchor: {
		height: 1,
		pointerEvents: 'none',
		position: 'absolute',
		width: 1,
		zIndex: 2,
	},
	// The suggestion list rendered inside the autocomplete popover. We style this wrapper as the
	// visible card (opaque background, border, radius, shadow) so it reads as a proper menu and
	// never lets the page bleed through behind the suggestions.
	mentionDropdown: {
		...THEME.common.scrollBar,
		background: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0 8px 24px 0 rgba(13, 15, 17, 0.12)',
		boxSizing: 'border-box',
		fontFamily: THEME.typography.fontFamilies.lexend,
		maxHeight: 280,
		minWidth: 320,
		overflowY: 'auto',
		padding: THEME.spacing.xs,
	},
	mentionEmptyState: {
		color: THEME.colors.text.light,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
	},
	mentionResultHandle: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	mentionResultItem: {
		alignItems: 'flex-start',
		background: 'transparent',
		border: 'none',
		borderRadius: THEME.common.borderRadius - 2,
		color: THEME.colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs / 2,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		textAlign: 'left',
		transition: 'background-color 0.1s ease-in-out',
		width: '100%',
		':hover': {
			background: THEME.colors.hover.light,
		},
	},
	mentionResultItemHighlighted: {
		background: THEME.colors.hover.light,
	},
	mentionResultName: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	mentionResultNameRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
		width: '100%',
	},
	modal: {
		...CssSelectors.allDescendants(
			{
				padding: 0,
			},
			'.modal-overlay-content'
		),
	},
	textAreaContainer: {
		padding: 14,
		paddingTop: 10,
		minHeight: 124,
		fieldSizing: 'content',
	},
	textAreaWrapper: {
		position: 'relative',
	},
});
